import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";
import moment from 'moment';
import Dropzone from 'react-dropzone';
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import _ from "lodash";
import mime from "mime-types";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

class IssueFiles extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            modalIsOpen: false,
            modalType: null
        }
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        })
    };

    // Dropzone
    onDrop = (acceptedFiles, rejectedFiles) => {
        const actualFiles = this.props.issue.get('files');
        const numFiles = acceptedFiles.length;
        const maxFiles = 10 - (actualFiles && actualFiles.size) || 0;
        const maxSize = 10 * 1024 * 1024; // 10 MB
        let maxFilesReached = false;
        let maxSizeReached = false;
        let totalSize = 0;

        acceptedFiles.map(file => totalSize = totalSize + file.size);

        if (numFiles > maxFiles) {
            maxFilesReached = true;
            this.props.addNotification({
                message: 'Has excedido el maximo de ficheros que puedes subir',
                color: 'red',
                icon: 'warning-sign'
            });
        }
        if (totalSize > maxSize) {
            maxSizeReached = true;
            this.props.addNotification({
                message: 'Has excedido el tamaño maximo de ficheros que puedes subir',
                color: 'red',
                icon: 'warning-sign'
            });
        }

        if (numFiles > 0 && !maxFilesReached && !maxSizeReached) {
            const files = new FormData();

            acceptedFiles.map(file => files.append('file', file));
            this.props.uploadIssueFiles(this.props.issue.get('_id'), files);
        }
    };

    render() {
        const tableData = this.props.issue.get('files');
        const tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false,
        };
        const tableColumns = {
            mimeType: {
                title: 'Tipo',
                columnType: 'function',
                dataField: 'mimeType',
                width: 100,
                style: { maxWidth: 100 },
                sortable: false,
                filterable: false,
                nodeContent: (type) => {
                    return _.upperCase(mime.extension(type));
                }
            },
            name: {
                title: "Nombre del documento",
                columnType: 'text',
                dataField: 'name',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            uploadDate: {
                title: 'Fecha de subida',
                columnType: 'function',
                dataField: 'createdAt',
                width: 100,
                style: { maxWidth: 150 },
                sortable: false,
                filterable: false,
                nodeContent: (date) => {
                    return moment(date).format('DD/MM/YYYY') ;
                }
            },
            size: {
                title: "Tamaño",
                columnType: 'function',
                dataField: 'size',
                width: 100,
                style: { maxWidth: 100 },
                sortable: false,
                filterable: true,
                nodeContent: (size) => {
                    return (size / 1024).toFixed(2) + ' KB';
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 90 },
                sortable: false,
                filterable: false,
                nodeContent: (fileId) => {
                    return (
                        <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                            <Icon className="cursor-pointer" icon="download" title="Descargar" onClick={() => {
                                this.props.downloadIssueFile(this.props.issue.get('_id'), fileId);
                            }} />
                            <Icon style={{ marginLeft: 7 }} className="cursor-pointer" icon="trash" title="Eliminar" onClick={() => {
                                this.props.deleteIssueFile(this.props.issue.get('_id'), fileId);
                            }} />
                        </div>
                    );
                }
            }
        };

        let totalSize = 0;
        tableData.map(item => totalSize = totalSize + item.get('size'));

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        title: 'Borrado permanente',
                        body: null,
                        footer: null
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-danger">{tableData.size}</span>
                        <span>{ 'Documentos (' + ((totalSize / 1024) / 1024).toFixed(2) + ' MB)' }</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginTop: 20 }} >
                    <div className="col">
                        { tableData.size < 10
                            ? <Dropzone
                                style={{
                                    borderWidth: 2,
                                    borderStyle: 'dashed',
                                    borderColor: '#D1DADE',
                                    backgroundColor: 'rgba(243, 243, 244, 0.5)',
                                    color: '#2F4050',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    paddingBottom: 15
                                }}
                                acceptStyle={{
                                    borderColor: 'rgba(0, 255, 0, 0.5)',
                                    backgroundColor: 'rgba(0, 255, 0, 0.25)',
                                    color: 'rgba(0, 255, 0, 0.5)'
                                }}
                                rejectStyle={{
                                    borderColor: 'rgba(255, 0, 0, 0.5)',
                                    backgroundColor: 'rgba(255, 0, 0, 0.25)',
                                    color: 'rgba(255, 0, 0, 0.5)'
                                }}
                                accept={'application/pdf,image/jpeg,image/png,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'}
                                onDrop={this.onDrop}
                            >
                                <h2>Arrastrar documentos aquí (o hacer click) para subir un documento</h2>
                                <Icon icon="cloud-upload" iconSize={100} />
                            </Dropzone>
                            : null
                        }
                    </div>
                </div>
                <div className="row" style={{ marginTop: 5 }} >
                    <div className="col" style={{ textAlign: 'center' }} >
                        <span>
                            Extensiones de documento permitidas: PDF, JPG/JPEG, PNG, TXT, CSV, XLS/XLSX, DOC/DOCX - Tamaño máximo del documento 10MB - Nº máximo de documentos permitidos: 10
                        </span>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

export default IssueFiles;



// WEBPACK FOOTER //
// ./src/containers/sales/issues/IssueFiles.js